import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-validation-layout',
  templateUrl: './meter-validation-layout.component.html',
  styleUrls: ['./meter-validation-layout.component.scss']
})
export class MeterValidationLayoutComponent {

}
